import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useTheme } from "../context/ThemeContext";

const DashboardLayout = () => {
  const { isDarkMode } = useTheme();

  const mainBackgroundColor = isDarkMode ? "bg-black" : "bg-gray-50";
  const textColor = isDarkMode ? "text-white" : "text-gray-900";

  return (
    <div className={`flex ${mainBackgroundColor} ${textColor} min-h-screen ${!isDarkMode ? 'light-mode' : ''}`}>
      <Sidebar />

      <main className={`flex-1 ml-64 p-6 ${mainBackgroundColor}`}>
        <Header />
        <div className="mt-4">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
